import { Metamodel } from 'app/model/base/model';
import { SingleStreamOutputTransformation } from './single-output-stream.transformation';
import { DataFlowExpression } from './dataflowexpression';
import { Owned } from '../base/named';
import { updateIdentifiers, asyncUpdateIdentifiers } from './dataflow-expression-update-identifiers';
import { convertColumnRefToDataFlowColumn, convertParametersToArguments, convertCacheSinksToArguments } from './dataflow-expression-utilities';
import { DataFlowExpressionFunctions } from './dataflow-expression-functions';
import { format } from 'app/shared/utils/string.util';

import { DataFlowColumn } from '../dataset/dataflowcolumn';
import { IExtraFieldInfo } from 'app/interfaces/IExtraFieldInfo';
import { BooleanDataFlowType } from './dataflow-datatype';
import { GlobalVariables } from 'app/services/globals';

@Metamodel.model({
    name: 'baserowmodifiertransformation', // As this is abstract this will never be used
    abstract: true
})
export abstract class BaseRowModifierTransformation extends SingleStreamOutputTransformation {
    public transformationLabel: string = '';
    public inspectDetailsOutputFields: IExtraFieldInfo[] = [
        {
            name: () => format(stringResources.UsedInTransformationLabel, this.transformationLabel),
            icon: this._isUsedInRowModifier.bind(this)
        }
    ];

    public static createExpression(owner: Owned): DataFlowExpression {
        const condition = Owned.create<DataFlowExpression>(DataFlowExpression.MODEL, owner);
        condition.requiredReturnType = BooleanDataFlowType.TYPE;
        return condition;
    }

    protected updateInputTransformationCacheInternal(): void {
        super.updateInputTransformationCacheInternal();
        this.getExpressions().forEach((expression: DataFlowExpression) => {
            if (GlobalVariables.validateDataFlowAPI) {
                asyncUpdateIdentifiers({
                    dataFlowColumns: convertColumnRefToDataFlowColumn(this.distinctInputColumnRefs),
                    dataFlowFunctions: DataFlowExpressionFunctions.ALL_FUNCTIONS,
                    dataFlowParameters: convertParametersToArguments(this.dataflow.parameters),
                    dataFlowTransientColumns: convertColumnRefToDataFlowColumn(this.transientColumnRefs),
                    dataFlowCacheSinks: convertCacheSinksToArguments(this.dataflow.cacheSinks)
                }, expression, this);
            } else {
                updateIdentifiers({
                    dataFlowColumns: convertColumnRefToDataFlowColumn(this.distinctInputColumnRefs),
                    dataFlowFunctions: DataFlowExpressionFunctions.ALL_FUNCTIONS,
                    dataFlowParameters: convertParametersToArguments(this.dataflow.parameters),
                    dataFlowTransientColumns: convertColumnRefToDataFlowColumn(this.transientColumnRefs),
                    dataFlowCacheSinks: convertCacheSinksToArguments(this.dataflow.cacheSinks)
                }, expression);
            }
        });
    }

    protected get descriptionMsg(): string {
        return '';
    }

    protected get noDescriptionMsg(): string {
        return '';
    }

    protected getGeneratedDescription(): string {
        const columnNames: Set<string> = new Set<string>();
        this.getExpressions().forEach((condition) => {
            if (condition.argumentsUsed.dataFlowColumns.length > 0) {
                columnNames.add(condition.argumentsUsed.dataFlowColumns.map((dataFlowColumn) => dataFlowColumn.column.name).join(', '));
            }
        });
        if (columnNames.size) {
            return format(this.descriptionMsg, Array.from(columnNames).join(', '));
        }
        return this.noDescriptionMsg;
    }

    private _isUsedInRowModifier(column: DataFlowColumn): string {
        return this.getExpressions().find((condition) => !!condition.argumentsUsed.dataFlowColumns.find((x) => x.column.name === column.name)) ? 'svg-i-20x20-checkmark' : '';
    }
}
